export default {
  // 视频通话记录报表
  biByVideoCallApi: '/backstageApi/account/backstage/BI/videoCall',
  //  机型设备数量
  biBySelectDeviceNum: '/backstageApi/account/backstage/BI/selectDeviceNum',
  //  机型视频通话记录统计
  biBySelectModelVideoCall: '/backstageApi/account/backstage/BI/selectModelVideoCall',
  // 按月查询新增设备
  biBySelectMonthDeviceAdd: '/backstageApi/account/backstage/BI/selectMonthDeviceAdd',
  //  机型绑定的用户
  biBySelectModelBindAppUser: '/backstageApi/account/backstage/BI/selectModelBindAppUser',
  //  首页-当日照片上传数量
  biBySelectAppUserUploadAction: '/backstageApi/account/backstage/BI/selectAppUserUploadAction',
  //  用户行为-图片上传- 网络类型
  biBySelectAppUserActionMonth: '/backstageApi/account/backstage/BI/selectAppUserActionMonth',
  // 设备活跃
  biBySelectDeviceAction: '/backstageApi/account/backstage/BI/selectDeviceAction',
  // 设备新增
  biBySelectDeviceAddByCreate: '/backstageApi/account/backstage/BI/selectDeviceAddByCreate',
  //  机型ota升级统计
  biBySelectOTAVersionStatistics: '/backstageApi/account/backstage/BI/selectOTAVersionStatistics',
  //  app用户统计对比
  biBySelectAppUserStatistics: '/backstageApi/account/backstage/BI/selectAppUserStatistics',
  //  本月往月设备新增(首页)
  biBySelectDeviceAdd: '/backstageApi/account/backstage/BI/selectDeviceAdd',
  //  本月新增机型(首页)
  biBySelectAddModelNum: '/backstageApi/account/backstage/BI/selectAddModelNum',
  //  本月新增ota(首页)
  biBySelectAddOTANum: '/backstageApi/account/backstage/BI/selectAddOTANum',
  //  本月ota升级成功统计(首页)
  biBySelectOTAUpgradeNum: '/backstageApi/account/backstage/BI/selectOTAUpgradeNum',
  //  获取机型当前版本
  biBySelectDeviceClientVersion: '/backstageApi/account/backstage/BI/selectDeviceClientVersion',
  //  获取机型当前版本:激活
  biBySelectDeviceClientVersionActivation: '/backstageApi/account/backstage/BI/selectDeviceClientVersionActivation',
  //  获取已绑定用户数
  biBySelectUserBindNum: '/backstageApi/account/backstage/BI/selectUserBindNum',
  //  新增绑定用户统计-地区聚合
  biBySelectUserBind: '/backstageApi/account/backstage/BI/selectUserBind',
  //  新增设备-地区聚合
  biBySelectDeviceAddCountry: '/backstageApi/account/backstage/BI/selectDeviceAddByCountry',
  //  激活设备-地区聚合
  biBySelectDeviceActivated: '/backstageApi/account/backstage/BI/selectDeviceActivated',
  //  新增用户-地区聚合
  biBySelectUserAddByCountry: '/backstageApi/account/backstage/BI/selectUserAddByCountry',
  //  用户上传-地区聚合
  biBySelectUserUploadByCountry: '/backstageApi/account/backstage/BI/selectUserUploadByCountry',
  //  周用户新增
  biBySelectWeekUserAdd: '/backstageApi/account/backstage/BI/selectWeekUserAdd',
  // 用户上传数量-os+地区
  biBySelectUserUploadNumByOs: '/backstageApi/account/backstage/BI/selectUserUploadNumByOs',
  // 用户上传容量-os+地区
  biBySelectUserUploadSizeByOs: '/backstageApi/account/backstage/BI/selectUserUploadSizeByOs',
  // 相框出货数量
  biBySelectPhotoNum: '/backstageApi/account/backstage/BI/selectPhotoNum',
  // 周设备新增
  biBySelectWeeKDeviceAdd: '/backstageApi/account/backstage/BI/selectWeeKDeviceAdd',
  // 设备日登录统计
  biBySelectDeviceLoginDayLog: '/backstageApi/account/backstage/BI/selectDeviceLoginDayLog',
  // ota升级跟踪
  biBySelectOTATrack: '/backstageApi/account/backstage/BI/selectOTATrack',
  // 用户登录日志
  biBySelectUserLoginLog: '/backstageApi/account/backstage/BI/selectUserLoginLog',
  // 用户手机机型数量统计
  biByQueryUserModel: '/backstageApi/account/backstage/BI/queryUserModel',
  // 用户绑定设备记录
  biByQueryUserBindDeviceLog: '/backstageApi/account/backstage/BI/queryUserBindDeviceLog',
  // 用户上传记录
  biByQueryUploadPhotoLog: '/backstageApi/account/backstage/BI/queryUploadPhotoLog',
  // 客户端版本机型分组统计数量
  selectLatestVersionGroupModel: '/backstageApi/account/backstage/BI/selectLatestVersionGroupModel',
  queryMongodbDevice: '/backstageApi/account/backstage/BI/queryMongodbDevice',

  // app下载统计
  appDownloadGroupCountry : '/backstageApi/account/backstage/BI/appDownloadGroupCountry',
  appDownloadGroupCountryAndApkName : '/backstageApi/account/backstage/BI/appDownloadGroupCountryAndApkName',

  // apk升级统计
  apkUpgradeApi : "/backstageApi/account/backstage/BI/BIApkUpgrade",

  otaUpgradeApi : "/backstageApi/account/backstage/BI/findOTAUpgradeTo"



}

// 支付统计
import { axiosJSONPost} from '@/util/axios';
const api = {
  queryVipNumApi: '/backstageApi/account/backstage/BI/queryVipNum',
  queryNewAndExistingVipUserApi: '/backstageApi/account/backstage/BI/queryNewAndExistingVipUser',
  selectDayAndCountryGroupApi: '/backstageApi/account/backstage/BI/selectDayAndCountryGroup',
  queryVipUserIdListApi: '/backstageApi/account/backstage/BI/queryVipUserIdList',
  queryVipUserByDayApi: '/backstageApi/account/backstage/BI/queryVipUserByDay',
  queryVipUserByMonthApi: '/backstageApi/account/backstage/BI/queryVipUserByMonth',
  queryVipUserByYearApi: '/backstageApi/account/backstage/BI/queryVipUserByYear',
  queryVipUserCountryByStatusApi: '/backstageApi/account/backstage/BI/queryVipUserCountryByStatus',
  queryVipUserByVipPackageApi: '/backstageApi/account/backstage/BI/queryVipUserByVipPackage',
  queryVipUserByStatusApi: '/backstageApi/account/backstage/BI/queryVipUserByStatus',
  queryAddUserVipProGroupMonthApi: '/backstageApi/account/backstage/BI/queryAddUserVipProGroupMonth',
  queryAddUserVipProGroupDayApi: '/backstageApi/account/backstage/BI/queryAddUserVipProGroupDay',
  queryVipUserByOsGroupApi: '/backstageApi/account/backstage/BI/queryVipUserByOsGroup',
  queryAmountByMonthApi: '/backstageApi/account/backstage/BI/queryAmountByMonth',
}

export const queryVipNum = async (param) => await axiosJSONPost(api.queryVipNumApi, param)
export const queryNewAndExistingVipUser = async (param) => await axiosJSONPost(api.queryNewAndExistingVipUserApi, param)
export const selectDayAndCountryGroup = async (param) => await axiosJSONPost(api.selectDayAndCountryGroupApi, param)
export const queryVipUserIdList = async (param) => await axiosJSONPost(api.queryVipUserIdListApi, param)
export const queryVipUserByDay = async (param) => await axiosJSONPost(api.queryVipUserByDayApi, param)
export const queryVipUserByMonth = async (param) => await axiosJSONPost(api.queryVipUserByMonthApi, param)
export const queryVipUserByYear = async (param) => await axiosJSONPost(api.queryVipUserByYearApi, param)
export const queryVipUserCountryByStatus = async (param) => await axiosJSONPost(api.queryVipUserCountryByStatusApi, param)
export const queryVipUserByVipPackage = async (param) => await axiosJSONPost(api.queryVipUserByVipPackageApi, param)
export const queryVipUserByStatus = async (param) => await axiosJSONPost(api.queryVipUserByStatusApi, param)
export const queryAddUserVipProGroupMonth = async (param) => await axiosJSONPost(api.queryAddUserVipProGroupMonthApi, param)
export const queryAddUserVipProGroupDay = async (param) => await axiosJSONPost(api.queryAddUserVipProGroupDayApi, param)
export const queryVipUserByOsGroup = async (param) => await axiosJSONPost(api.queryVipUserByOsGroupApi, param)
export const queryAmountByMonth = async (param) => await axiosJSONPost(api.queryAmountByMonthApi, param)












// WEBPACK FOOTER //
// ./src/api/bi/bi.js